import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import {
    createPerpayPlusSoloEnrollment as createPerpayPlusSoloEnrollmentAction,
    createPerpayPlusSoloEnrollmentError,
    createPerpayPlusSoloEnrollmentSuccess,
    createPerpayPlusSoloFeatureEnrollment as createPerpayPlusSoloFeatureEnrollmentAction,
    createPerpayPlusSoloFeatureEnrollmentSuccess,
    createPerpayPlusSoloFeatureEnrollmentError,
} from '@perpay-web/fintech/actions/entities/perpayPlusSolo';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import { PERPAY_PLUS_SOLO } from '@perpay-web/fintech/constants/featureTypes';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const createPerpayPlusSoloEnrollmentEpic = (action$, state$) =>
    action$.pipe(
        ofType(createPerpayPlusSoloEnrollmentAction().type),
        exhaustMap((action) =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [
                    createPerpayPlusSoloFeatureEnrollmentAction({
                        feature: PERPAY_PLUS_SOLO,
                    }),
                ],
                waitFor: [createPerpayPlusSoloFeatureEnrollmentSuccess().type],
                waitForDispatch: () => [
                    createPerpayPlusSoloEnrollmentSuccess(),
                    routeToLocation({
                        path:
                            action.payload && action.payload.next
                                ? action.payload.next
                                : paths.perpayPlusSoloApplication.path,
                        replace: true,
                    }),
                ],
                errors: [createPerpayPlusSoloFeatureEnrollmentError().type],
                errorDispatch: (error) => [
                    createPerpayPlusSoloEnrollmentError(error),
                ],
            }),
        ),
    );
